import * as React from 'react';
import { Text } from '@amzn/storm-ui';
import { AccountLabel } from './AccountLabel';
import { FlexContainer } from 'src/commons/components/FlexContainer';
import { Container } from 'src/commons/components/Container';
import { RetailerName } from './IA2AdvertisingAccountItem';

type IA2MobileAccountListItemProps = {
  accountLabel: string;
  countryLabel: string;
  retailerName?: string;
};

export const IA2MobileAccountListItem: React.FC<
  IA2MobileAccountListItemProps
> = ({ accountLabel, countryLabel, retailerName }) => {
  return (
    <FlexContainer justifyContent="space-between">
      <Container>
        <AccountLabel label={accountLabel} />
        {retailerName && (
          <RetailerName size="xsmall">{retailerName}</RetailerName>
        )}
        <Text color="tertiary">{countryLabel}</Text>
      </Container>
    </FlexContainer>
  );
};
